<template>
  <div class="tg-star-awards-2025">
    <div class="tg-star-awards-2025_banner">
    </div>
    <div class="tg-star-awards-2025_category tg-star-awards-2025_container tg-star-awards-2025_flexc">
      <p v-for="(item, index) in categoryTitle" :key="item" @click="activeIndex = index">
        <img :src="activeIndex === index ? require(`./images/t${index+1}_ok.png`):require(`./images/t${index+1}.png`)" alt="">
      </p>
    </div>
     <!-- 奖项内容 -->
    <div
      v-for="(awards, index) in categoryContent"
      :key="index"
      class="tg-star-awards-2025_content tg-star-awards-2025_container"
      v-show="activeIndex === index"
    >
      <div class="awards-item" v-for="(award, aindex) in awards" :key="'award'+aindex">
        <div class="title">
          <h3>{{award.name}}</h3>
          <p>{{award.intro}}</p>
        </div>
        <div class="flex-between">
          <div class="game-item" v-for="(game, gindex) in award.games" :key="'game'+gindex">
            <div>
              <img :src="require(`./images/${categoryImg[index]}/${aindex+1}-${gindex+1}.jpg`)" onerror="this.src='./images/game/1-1.jpg'" alt="">
            </div>
            <div>{{ game }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  async asyncData({ route, store }) {
    await Promise.all([store.dispatch(`tgs/INIT_DATA`), store.dispatch(`tgs/FETCH`)]);
    // 返回 SSR 上下文，用于插入到 head 内
    return {};
  },
  data() {
    return {
      activeIndex: 0,
      categoryTitle: ['游戏类', '业界类'],
      categoryImg: ['game', 'hardware'],
      categoryContent: [
        [
          {
            name: '年度游戏巨星奖',
            intro: '今年销量和口碑双双最佳的游戏作品',
            games: [
              '光与影：33号远征队',
              '双影奇境',
              '逃离鸭科夫',
              '天国：拯救II'
            ]
          },
          {
            name: '单机游戏杰出奖',
            intro: '在单机游戏中获得市场认可的佳作',
            games: [
              '光与影：33号远征队',
              '空洞骑士：丝之歌',
              '死亡搁浅2',
              '逃离鸭科夫'
            ]
          },
          {
            name: '移动游戏翘楚奖',
            intro: '在移动市场推出便获得成功的新手游',
            games: [
              '鸣潮',
              '女神异闻录：夜幕魅影',
              '胜利女神：新的希望',
              '无畏契约：源能行动'
            ]
          },
          {
            name: '独立游戏新星奖',
            intro: '在独立游戏中脱颖而出的亮眼之作',
            games: [
              '黑帝斯2',
              '空洞骑士：丝之歌',
              '米塔',
              'PEAK'
            ]
          },
          {
            name: '国产游戏不凡奖',
            intro: '国内开发者推出的具有浓郁中国特色的作品',
            games: [
              '明末：渊虚之羽',
              '苏丹的游戏',
              '逃离鸭科夫',
              '无限机兵'
            ]
          },
          {
            name: '卓越游戏发行奖',
            intro: '在海内外成功发行单款/多款游戏的游戏发行商',
            games: [
              '网易游戏',
              'Electronic-Arts',
              'Kepler-Interactive',
              'SEGA'
            ]
          }
        ],
        [
          {
            name: '超人气游戏外设',
            intro: '今年上市获得成功的游戏周边外设',
            games: [
              '八位堂-Pro-3-蓝牙手柄',
              '八位堂天刃星街机控制器-紫透双签版',
              '雷蛇-炼狱蝰蛇-V4-Pro',
              'ATK-A98-Pro'
            ]
          },
          {
            name: '超人气游戏硬件',
            intro: '今年上市获得成功的游戏硬件',
            games: [
              'AYN-Thor',
              'Nintendo-Switch-2',
              'PlayStation-5-Pro',
              'ROG-Xbox-Ally-X'
            ]
          },
          {
            name: '超人气游戏手机',
            intro: '今年上市获得成功的游戏手机',
            games: [
              '红魔11-Pro',
              '一加-Ace-5-至尊版',
              'iPhone-17-Pro-Max',
              'Redmi-K80-至尊版'
            ]
          },
          {
            name: '超人气数码产品',
            intro: '今年上市获得成功的游戏数码类产品',
            games: [
              '惠普OMEN-暗影精灵11',
              '机械革命极光X',
              '联想拯救者Y9000P至尊版',
              'ROG-幻14-Air-2025'
            ]
          },
          {
            name: '超人气显示设备',
            intro: '今年上市获得成功的显示器等显示外设',
            games: [
              '三星 S85F 电视',
              '三星27英寸OLED显示器G81SF',
              'AGON CS24A',
              'EVNIA弈威27M2N8800'
            ]
          },
          {
            name: '超人气音频产品',
            intro: '今年上市获得成功的音频产品',
            games: [
              '华为-FreeBuds-6i',
              'Apple-AirPods-Pro-3',
              'Bose-QuietComfort-Ultra-Earbuds',
              'Sony-WF-1000XM5'
            ]
          }
        ]
      ]
    };
  }
};
</script>
